import { TableFilterReferenceEnum } from '@omnea-app/packages/universal/hasura/graphql'

export const tableFiltersQueryKey = 'tableFilters' as const

export const tableFiltersQueryKeys = {
  listTableFilters: [tableFiltersQueryKey, 'list'] as const,
  getTableFilterById: (id: string) => [tableFiltersQueryKey, 'detail', id] as const,
  getTableFiltersByReference: (reference?: TableFilterReferenceEnum) => [tableFiltersQueryKey, 'filter', reference] as const,
}
